//import mdui from "mdui/dist/js/mdui.esm.js";
import mdui from "./mdui/mdui.esm.js";
export default mdui;
